import * as React from "react"
import { SVGProps } from "react"

const UpChevronIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#fff"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="#fff"
    className="w-6 h-6"
    {...props}
  >
    <title>Close Menu</title>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 8.25l-7.5 7.5-7.5-7.5"
    />
  </svg>
)

export default UpChevronIcon
